<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      ref="editForm"
      :title="editFormDialogOptions.title"
      :visible.sync="editFormDialogOptions.visible"
      :disabled="editFormDialogOptions.disabled"
      :platformTemplateCode="editFormDialogOptions.platformTemplateCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import EditForm from '../edit-form'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, EditForm },
  data() {
    return {
      usePage: true,
      editFormDialogOptions: { visible: false, platformTemplateCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomOrderPlatformTransformTemplateListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data = {} }) {
      const types = {
        edit: '编辑账户信息',
        add: '新增账户信息',
        detail: '账户详情信息',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        platformTemplateCode: data.platformTemplateCode,
        disabled: type === 'detail',
      }
    },
  },
}
</script>
